module.exports = __webpack_public_path__ + "img/tolx.4195d446.png";